import gsap from "gsap";
import { SplitText } from "gsap/SplitText";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { createScrollReveal } from "../../utils/createScrollReveal";

gsap.registerPlugin(SplitText, ScrollTrigger);

const EASE = "expo.out";
const DURATION = 0.9;
// Each next element starts before the previous one finishes, so the reveal
// reads as one overlapping motion instead of three sequential ones.
const OVERLAP = "-=0.5";

export default class TitleSubtitleCtaPush {
  constructor(el) {
    this.el = el;
    this.setupReveal();
  }

  setupReveal() {
    const title = this.el.querySelector(".c-title-subtitle-cta-push__title");
    if (!title) return;

    this.reveal = createScrollReveal({
      trigger: this.el,
      build: () => {
        const subtitle = this.el.querySelector(".c-title-subtitle-cta-push__subtitle");
        const link = this.el.querySelector(".c-title-subtitle-cta-push__link");
        const splits = [];

        const splitLines = (target) => {
          const split = new SplitText(target, { type: "lines" });
          splits.push(split);
          return split.lines;
        };

        const titleLines = splitLines(title);
        const subtitleLines = subtitle ? splitLines(subtitle) : [];

        // Set explicitly rather than relying on .fromTo()'s immediateRender:
        // that only applies to the tween sitting at the timeline's current
        // position (0, the title) — the subtitle/link tweens start later
        // (OVERLAP), so without this they'd sit in their final, untranslated
        // state until playback actually reaches them.
        gsap.set(titleLines, { y: "100%", opacity: 0 });
        if (subtitleLines.length) gsap.set(subtitleLines, { y: "100%", opacity: 0 });
        if (link) gsap.set(link, { opacity: 0 });

        const tl = gsap.timeline({ paused: true });

        tl.to(titleLines, { y: "0%", opacity: 1, duration: DURATION, ease: EASE, stagger: 0.1 }, 0);

        if (subtitleLines.length) {
          tl.to(subtitleLines, { y: "0%", opacity: 1, duration: DURATION, ease: EASE, stagger: 0.1 }, OVERLAP);
        }

        if (link) {
          tl.to(link, { opacity: 1, duration: DURATION, ease: EASE }, OVERLAP);
        }

        return {
          tl,
          teardown: () => splits.forEach((s) => s.revert()),
        };
      },
    });
  }

  destroy() {
    this.reveal?.destroy();
  }
}
